// import React, { useEffect, useRef } from "react";
// export default function CKeditor({ onChange, editorLoaded, name, value }) {

//     const editorRef = useRef();
//     const { CKEditor, ClassicEditor } = editorRef.current || {};
// useEffect(() => {
//     editorRef.current = {
//          CKEditor: require("@ckeditor/ckeditor5-react").CKEditor, 
//          //ClassicEditor: require("@ckeditor/ckeditor5-build-classic"),
//          ClassicEditor: require("ckeditor5-classic-plus"),
//         };
//     }, []);
//     console.log(CKEditor,"CKEditor")
//     return (
//         <>
//             {editorLoaded  ? (
//                 <CKEditor
//                     type=""
//                     name={name}
//                     editor={ClassicEditor}
//                     data={value}
//                     onChange={(event, editor) => {
//                         const data = editor.getData();
//                         onChange(data);
//                     }}
//                 />
//             ) : (
//                 <div>Editor loading</div>
//             )}
//         </>
//     )
// }

import React, { useEffect, useState } from "react";

export default function CKeditor({ onChange, editorLoaded, name, value }) {
  const [editorModules, setEditorModules] = useState({
    CKEditor: null,
    ClassicEditor: null,
  });

  useEffect(() => {
    const loadEditor = async () => {
      const { CKEditor } = await import("@ckeditor/ckeditor5-react");
      const ClassicEditor = await import("ckeditor5-classic-plus");
      setEditorModules({
        CKEditor,
        ClassicEditor: ClassicEditor.default,
      });
    };

    loadEditor();
  }, []);

  const { CKEditor, ClassicEditor } = editorModules;

  return (
    <>
      {CKEditor && ClassicEditor && editorLoaded ? (
        <CKEditor
          name={name}
          editor={ClassicEditor}
          data={value}
          onChange={(event, editor) => {
            const data = editor.getData();
            onChange(data);
          }}
        />
      ) : (
        <div>Editor loading...</div>
      )}
    </>
  );
}
